export const productName = 'MEGA PACK GEOLOGÍA LISTO';
export const productImage =
  'https://cdn.magicpatterns.com/uploads/nyCymVpvYjMo8fQVjvKbNN/MOCKUP_12.03.19_a._m..png';

export const checkoutUrl = 'https://megapack-geologia-listo.impultienda.ar/checkout';

export const price = 'USD 19,00';
export const priceBefore = 'USD 40,00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70,00';

export const included = [
  'Tomo 1 — Fundamentos de Geología',
  'Tomo 2 — Minerales, Rocas y Ciclo Geológico',
  'Tomo 3 — Tectónica de Placas y Deformación',
  'Tomo 4 — Sismos, Volcanismo y Riesgos',
  'Tomo 5 — Geomorfología y Paisajes',
  'Tomo 6 — Estratigrafía, Fósiles y Tiempo Geológico',
  'Tomo 7 — Agua Subterránea y Recursos',
  'Tomo 8 — Casos Prácticos y Desafíos',
  'Tomo 9 — Planificación y Proyectos 2026',
  'Bono 1 — 150 Actividades y Prácticas',
  'Bono 2 — Kit de Evaluaciones Completo',
  'Bono 3 — 100 Casos Problemáticos',
  'Bono 4 — 60 Prácticas de Laboratorio',
  'Bono 5 — 200 Conceptos Clave',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];

export const systemNegatives = [
  'No es teoría copiada de un manual desactualizado.',
  'No es una colección de prácticas sueltas sin coherencia.',
  'No es material que tengas que adaptar entero.',
];

export const closingLines = [
  'Sin más noches buscando cómo explicar conceptos de geología complejos',
  'Sin más clases armadas de apuro con material que no funciona',
  'Sin más alumnos desconectados que no entienden para qué sirve la geología',
  'Sin más fines de semana perdidos construyendo material desde cero',
  'Sin más silencios incómodos frente a preguntas técnicas que te ponen en aprietos',
];
